import { Box, Stack, Typography } from "@mui/material";
import { differenceInYears } from "date-fns";
import { useMemo } from "react";
import { useLoaderData } from "react-router-dom";
import { DetailedEmployee } from "src/api/types";

import MasonryLayout from "src/components/MasonryLayout";
import MasonryColumnsSelector from "src/components/MasonryLayout/components/MasonryColumnsSelector";
import UserInfo from "./components/UserInfo";
import ProviderInfo from "./components/ProviderInfo";
import Licenses from "./components/Licenses";
import Specialties from "./components/Specialties";
import EmployeeRoles from "./components/EmployeeRoles";
import ProviderEPrescribe from "src/components/ProviderEPrescribe";

const Employee = () => {
  const employee = useLoaderData<DetailedEmployee>();

  const employeeInfo = useMemo(() => {
    const age = differenceInYears(new Date(), new Date(employee?.dob || ""));

    return `${employee?.first_name} ${employee?.last_name}, ${age || null}, ${
      employee?.gender
    }`;
  }, [employee]);

  return (
    <Stack width="100%" gap={2}>
      <Stack direction="row" gap={2}>
        <Typography variant="h4">Employee:</Typography>
        <Typography variant="h4">{employeeInfo}</Typography>
        <Box ml="auto">
          <MasonryColumnsSelector />
        </Box>
      </Stack>

      <MasonryLayout spacing={1}>
        <UserInfo user={employee} />
        <ProviderEPrescribe user={employee} />
        {employee.provider ? (
          <>
            <ProviderInfo provider={employee.provider} />
            <Licenses providerId={employee.provider.id} />
            <Specialties providerId={employee.provider.id} />
          </>
        ) : null}
        <EmployeeRoles userId={employee.id} />
      </MasonryLayout>
    </Stack>
  );
};

export default Employee;
